import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.942 17.243L13 19.433V11.87l6-3.32v5.197a3.998 3.998 0 01-2.058 3.495zM5 13.748V8.506l6 3.361v7.565l-3.943-2.189A3.999 3.999 0 015 13.748zm5.058-9.245A4.011 4.011 0 0112 4a4.01 4.01 0 011.941.503l4.113 2.284-6.05 3.351-6.02-3.374 4.074-2.26zm9.91 1.06l-5.056-2.809a5.998 5.998 0 00-5.824 0L4.031 5.562a2.002 2.002 0 00-1.03 1.751v6.435a5.997 5.997 0 003.086 5.244l4.94 2.743c.605.336 1.34.336 1.945 0l4.941-2.743A5.999 5.999 0 0021 13.748V7.313a2 2 0 00-1.032-1.75z"
    />
  </svg>
);
